import { useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();
    const guest = to.matched.some((record) => record.meta.guest);

    if (guest && userStore.isLoggedIn) {
        next('/');
    } else {
        next();
    }
}
